import styled from "styled-components";

export const TourContent = styled.div`
    text-align: center;
`;

export const TourHeader = styled.div`
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.31;
    letter-spacing: normal;
    text-align: center;
    color: #1e3c50;
    margin: 24px 0;
`;

export const TourDescription = styled.div`
    font-size: 16px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #626e82;
    padding: 0px 39px;
    margin-bottom: 24px;
`;

export const TourDescriptionSteps = styled(TourDescription)`
    padding: 0px 12px;
    width: 400px;
    text-align: left;
    margin-bottom: unset;
`;

export const TooltipBody = styled.div`
    border-radius: 12px;
    box-shadow: 0 0 16px 0 rgba(0, 38, 111, 0.06);
    background-color: #ffffff;
`;

export const TooltipContent = styled.div`
    padding: 12px;
`;

export const TooltipFooter = styled.div`
    border-top: 2px solid #dce0e8;
    padding: 12px;
    align-items: center;
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
`;

export const BackButton = styled.button`
    border-radius: 21px;
    background-color: #f0f3f7;
    padding: 0px 24px;
    height: 42px;
    font-size: 16px;
    font-weight: bold;
    color: #626e82;
    border: none;
    margin-right: 12px;

    &:focus {
        outline: none;
    }
`;

export const NextButton = styled.button`
    border-radius: 21px;
    background-color: #008561;
    padding: 0px 24px;
    height: 42px;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    border: none;

    &:focus {
        outline: none;
    }
`;

export const CloseButton = styled.button`
    background-color: transparent;
    border: 0px;
    border-radius: 0px;
    cursor: pointer;
    font-size: 16px;
    color: "#626e82";

    &:focus {
        outline: none;
    }
`;

export const DivCloseButton = styled.div`
    flex: 1 1 0%;
`;



